export enum EntityStateType {
    active = 0,
    readonly = 1,
    inactive = 2
}

export const ENTITY_STATE = [
    EntityStateType.active,
    EntityStateType.readonly,
    EntityStateType.inactive
]